import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangleIcon, FileTextIcon, DollarSignIcon, CheckCircleIcon, RotateCcwIcon, ChevronRightIcon, ServerIcon, RefreshCcwIcon, LinkIcon, SettingsIcon } from 'lucide-react';
import { mockBills } from '../utils/mockBills';
export function Notifications() {
  const navigate = useNavigate();
  const pendingBills = mockBills.filter(b => b.status === 'pending_approval');
  const recentActivity = [{
    id: 1,
    type: 'payment',
    title: 'Payment received',
    desc: 'THB 45,000 from John Doe',
    time: '10 mins ago',
    icon: DollarSignIcon,
    color: 'text-gray-600 bg-gray-100'
  }, {
    id: 2,
    type: 'bill',
    title: 'Bill approved',
    desc: 'INV-2026-003 by Simon Verraest',
    time: '1 hour ago',
    icon: CheckCircleIcon,
    color: 'text-gray-600 bg-gray-100'
  }, {
    id: 3,
    type: 'dispute',
    title: 'New dispute opened',
    desc: 'THB 1,538.94 - Fraudulent',
    time: '3 hours ago',
    icon: AlertTriangleIcon,
    color: 'text-gray-600 bg-gray-100'
  }, {
    id: 4,
    type: 'refund',
    title: 'Refund processed',
    desc: 'THB 2,500 to Sarah Smith',
    time: '5 hours ago',
    icon: RotateCcwIcon,
    color: 'text-gray-600 bg-gray-100'
  }, {
    id: 5,
    type: 'payment',
    title: 'Payment received',
    desc: 'THB 12,400 from Acme Corp',
    time: 'Yesterday',
    icon: DollarSignIcon,
    color: 'text-gray-600 bg-gray-100'
  }];
  return <div data-id="element-9295">
      {/* Page Header */}
      <div className="flex items-center justify-between mb-6" data-id="element-9296">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-9297">Notifications</h1>
        <button onClick={() => navigate('/settings')} className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors shadow-sm" data-id="element-9298">
          <SettingsIcon size={14} data-id="element-9299" />
          Manage preferences
        </button>
      </div>

      {/* Notification Center */}
      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-9300">
        {/* Section: Urgent */}
        <div className="px-5 py-3 bg-gray-50 border-b border-gray-200" data-id="element-9301">
          <h3 className="text-xs font-semibold text-gray-700 uppercase tracking-wider flex items-center gap-2" data-id="element-9302">
            <span className="w-2 h-2 rounded-full bg-red-500" data-id="element-9303"></span>
            Urgent — Requires Immediate Action
          </h3>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-9304">
          <button onClick={() => navigate('/disputes/1')} className="w-full flex items-center gap-4 px-5 py-4 hover:bg-gray-50 transition-colors text-left" data-id="element-9305">
            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-9306">
              <AlertTriangleIcon size={16} className="text-gray-600" data-id="element-9307" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-9308">
              <p className="text-sm font-medium text-gray-900" data-id="element-9309">
                Dispute #DP-2024-0001 requires response
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-9310">
                THB 100.01 · Fraudulent charge
              </p>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-9311">
              <span className="text-xs font-semibold text-red-600 bg-red-50 px-2 py-1 rounded" data-id="element-9312">
                Due in 2h
              </span>
            </div>
            <ChevronRightIcon size={16} className="text-gray-300 flex-shrink-0" data-id="element-9313" />
          </button>
          <button onClick={() => navigate('/disputes/91')} className="w-full flex items-center gap-4 px-5 py-4 hover:bg-gray-50 transition-colors text-left" data-id="element-9314">
            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-9315">
              <AlertTriangleIcon size={16} className="text-gray-600" data-id="element-9316" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-9317">
              <p className="text-sm font-medium text-gray-900" data-id="element-9318">
                Dispute #DP-2024-0091 requires response
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-9319">
                THB 1,538.94 · Duplicate charge
              </p>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-9320">
              <span className="text-xs font-semibold text-red-600 bg-red-50 px-2 py-1 rounded" data-id="element-9321">
                Due in 5h
              </span>
            </div>
            <ChevronRightIcon size={16} className="text-gray-300 flex-shrink-0" data-id="element-9322" />
          </button>
        </div>

        {/* Section: Bills */}
        <div className="px-5 py-3 bg-gray-50 border-b border-gray-200 border-t border-t-gray-200" data-id="element-9323">
          <h3 className="text-xs font-semibold text-gray-700 uppercase tracking-wider flex items-center gap-2" data-id="element-9324">
            <span className="w-2 h-2 rounded-full bg-[#FF4500]" data-id="element-9325"></span>
            Bills Pending Approval — {pendingBills.length} items
          </h3>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-9326">
          {pendingBills.slice(0, 4).map(bill => <button key={bill.id} onClick={() => navigate(`/bill-detail/${bill.id}`)} className="w-full flex items-center gap-4 px-5 py-4 hover:bg-gray-50 transition-colors text-left" data-id="element-9327">
              <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-9328">
                <FileTextIcon size={16} className="text-gray-600" data-id="element-9329" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-9330">
                <p className="text-sm font-medium text-gray-900" data-id="element-9331">
                  {bill.supplierName}
                </p>
                <p className="text-xs text-gray-500 mt-0.5" data-id="element-9332">
                  {bill.billNumber} · Due{' '}
                  {new Date(bill.dueDate).toLocaleDateString('en-GB')}
                </p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-9333">
                <p className="text-sm font-semibold text-gray-900" data-id="element-9334">
                  {bill.currency} {bill.amount.toLocaleString()}
                </p>
              </div>
              <ChevronRightIcon size={16} className="text-gray-300 flex-shrink-0" data-id="element-9335" />
            </button>)}
          {pendingBills.length > 4 && <button onClick={() => navigate('/bills')} className="w-full px-5 py-3 text-sm font-medium text-[#FF4500] hover:bg-gray-50 transition-colors text-center" data-id="element-9336">
              View all {pendingBills.length} pending bills →
            </button>}
        </div>

        {/* Section: Recent Activity */}
        <div className="px-5 py-3 bg-gray-50 border-b border-gray-200 border-t border-t-gray-200" data-id="element-9337">
          <h3 className="text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-9338">
            Recent Activity
          </h3>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-9339">
          {recentActivity.map(activity => <div key={activity.id} className="flex items-center gap-4 px-5 py-4" data-id="element-9340">
              <div className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 ${activity.color}`} data-id="element-9341">
                <activity.icon size={16} data-id="element-9342" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-9343">
                <p className="text-sm font-medium text-gray-900" data-id="element-9344">
                  {activity.title}
                </p>
                <p className="text-xs text-gray-500 mt-0.5" data-id="element-9345">{activity.desc}</p>
              </div>
              <span className="text-xs text-gray-400 flex-shrink-0" data-id="element-9346">
                {activity.time}
              </span>
            </div>)}
        </div>

        {/* Section: System */}
        <div className="px-5 py-3 bg-gray-50 border-b border-gray-200 border-t border-t-gray-200" data-id="element-9347">
          <h3 className="text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-9348">
            System Status
          </h3>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-9349">
          <div className="flex items-center gap-4 px-5 py-4" data-id="element-9350">
            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-9351">
              <ServerIcon size={16} className="text-gray-600" data-id="element-9352" />
            </div>
            <div className="flex-1" data-id="element-9353">
              <p className="text-sm font-medium text-gray-900" data-id="element-9354">API Uptime</p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-9355">
                All systems operational
              </p>
            </div>
            <span className="text-sm font-bold text-green-600" data-id="element-9356">99.99%</span>
          </div>
          <div className="flex items-center gap-4 px-5 py-4" data-id="element-9357">
            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-9358">
              <RefreshCcwIcon size={16} className="text-gray-600" data-id="element-9359" />
            </div>
            <div className="flex-1" data-id="element-9360">
              <p className="text-sm font-medium text-gray-900" data-id="element-9361">
                Last Settlement
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-9362">
                Completed successfully
              </p>
            </div>
            <span className="text-sm font-semibold text-gray-900" data-id="element-9363">
              01:30 AM
            </span>
          </div>
          <div className="flex items-center gap-4 px-5 py-4" data-id="element-9364">
            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-9365">
              <LinkIcon size={16} className="text-gray-600" data-id="element-9366" />
            </div>
            <div className="flex-1" data-id="element-9367">
              <p className="text-sm font-medium text-gray-900" data-id="element-9368">
                Active Payment Links
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-9369">
                Currently receiving traffic
              </p>
            </div>
            <span className="text-sm font-semibold text-gray-900" data-id="element-9370">142</span>
          </div>
        </div>
      </div>
    </div>;
}